import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SidebarEnum } from '../../models/common/sidebar.enum';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private readonly sidebarStateSubject: Subject<SidebarEnum> = new Subject<SidebarEnum>();
  sidebarStateObservable = this.sidebarStateSubject.asObservable();

  private readonly isMobileResolutionSubject: Subject<boolean> = new Subject<boolean>();
  isMobileResolutionObservable = this.isMobileResolutionSubject.asObservable();

  isCurrentlyMobileState = false;

  constructor() {  }

  setState(state:SidebarEnum){
    this.sidebarStateSubject.next(state);
  }

  setMobileState(isMobile: boolean){
    this.isCurrentlyMobileState = isMobile;
    this.isMobileResolutionSubject.next(isMobile);
  }

}
